// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Hero__Wrapper_LkLCC","Title":"Hero__Title_2UPkB","Grid":"Hero__Grid_10kUV","Links":"Hero__Links_1H6Sh","Link":"Hero__Link_1qhPt","Button":"Hero__Button_2luE8"};